/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Plant_Tree_TitleInputs */

const en_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay focused, and your seedling will become a beautiful tree.`)
};

const ar_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حافظ على تركيزك، وستتحول شتلتك إلى شجرة جميلة.`)
};

const de_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben Sie konzentriert, und Ihr Setzling wird zu einem schönen Baum werden.`)
};

const es_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantente concentrado y tu semilla se convertirá en un hermoso árbol.`)
};

const fr_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restez concentré et votre jeune pousse deviendra un bel arbre.`)
};

const it_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimani concentrato e la tua piantina diventerà un albero meraviglioso.`)
};

const ja_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中を続ければ、苗は美しい木に成長します`)
};

const ko_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중력을 유지하면 묘목이 아름다운 나무로 자라요.`)
};

const pt_br_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha o foco e sua muda se tornará uma bela árvore.`)
};

const ru_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжайте фокусироваться, и ваш саженец превратится в прекрасное дерево.`)
};

const th_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสให้มั่นคง แล้วต้นกล้าของคุณจะเติบโตเป็นต้นไม้ที่งดงาม`)
};

const tr_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmaya devam edersen ektiğin fidan güzel bir ağaca dönüşür.`)
};

const zh_cn_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`但只要你保持专注，树苗就会长成美丽的大树`)
};

const zh_tw_walkturough_plant_tree_title = /** @type {(inputs: Walkturough_Plant_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`但只要你保持專注，樹苗就會長成美麗的大樹`)
};

/**
* | output |
* | --- |
* | "Stay focused, and your seedling will become a beautiful tree." |
*
* @param {Walkturough_Plant_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_plant_tree_title = /** @type {((inputs?: Walkturough_Plant_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Plant_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_plant_tree_title(inputs)
	if (locale === "ar") return ar_walkturough_plant_tree_title(inputs)
	if (locale === "de") return de_walkturough_plant_tree_title(inputs)
	if (locale === "es") return es_walkturough_plant_tree_title(inputs)
	if (locale === "fr") return fr_walkturough_plant_tree_title(inputs)
	if (locale === "it") return it_walkturough_plant_tree_title(inputs)
	if (locale === "ja") return ja_walkturough_plant_tree_title(inputs)
	if (locale === "ko") return ko_walkturough_plant_tree_title(inputs)
	if (locale === "pt_br") return pt_br_walkturough_plant_tree_title(inputs)
	if (locale === "ru") return ru_walkturough_plant_tree_title(inputs)
	if (locale === "th") return th_walkturough_plant_tree_title(inputs)
	if (locale === "tr") return tr_walkturough_plant_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_plant_tree_title(inputs)
	return zh_tw_walkturough_plant_tree_title(inputs)
});